// export const notificationDataCategories = [
//   {
//     name: "Business and Finance",
//     value: "BUSINESS_AND_FINANCE",
//     children: [
//       {
//         name: "Daily Business Reports",
//         value: "DAILY_BUSINESS_REPORTS",
//         children: [
//           {
//             name: "Day End Business Report",
//             value: "DAY_END_BUSINESS_REPORT",
//           },
//           {
//             name: "Counter Closure Report",
//             value: "COUNTER_CLOSURE_REPORT",
//           },
//           {
//             name: "Counter Open Report",
//             value: "COUNTER_OPEN_REPORT",
//           },
//         ],
//       },
//       {
//         name: "Accounts",
//         value: "ACCOUNTS",
//         children: [
//           {
//             name: "Credit Entry Created",
//             value: "CREDIT_ENTRY_CREATED",
//           },
//           {
//             name: "Credit Entry Deleted",
//             value: "CREDIT_ENTRY_DELETED",
//           },
//           {
//             name: "Debit Entry Created",
//             value: "DEBIT_ENTRY_CREATED",
//           },
//           {
//             name: "Debit Entry Deleted",
//             value: "DEBIT_ENTRY_DELETED",
//           },
//           {
//             name: "Internal Transfer Entry Created",
//             value: "INTERNAL_TRANSFER_ENTRY_CREATED",
//           },
//           {
//             name: "Internal Transfer Entry Deleted",
//             value: "INTERNAL_TRANSFER_ENTRY_DELETED",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     name: "Inventory Management",
//     value: "INVENTORY_MANAGEMENT",
//     children: [
//       {
//         name: "Stock Alerts",
//         value: "STOCK_ALERTS",
//         children: [
//           {
//             name: "Low Stock Alert",
//             value: "LOW_STOCK_ALERT",
//           },
//         ],
//       },
//       {
//         name: "Purchase Orders (PO)",
//         value: "PURCHASE_ORDERS",
//         children: [
//           {
//             name: "PO Created",
//             value: "PO_CREATED",
//           },
//           {
//             name: "PO Edited",
//             value: "PO_EDITED",
//           },
//           {
//             name: "PO Deleted",
//             value: "PO_DELETED",
//           },
//           {
//             name: "PO Approval Needed",
//             value: "PO_APPROVAL_NEEDED",
//           },
//           {
//             name: "PO Approved",
//             value: "PO_APPROVED",
//           },
//           {
//             name: "PO Canceled",
//             value: "PO_CANCELED",
//           },
//           {
//             name: "PO Rejected",
//             value: "PO_REJECTED",
//           },
//         ],
//       },
//       {
//         name: "Requisitions",
//         value: "REQUISITIONS",
//         children: [
//           {
//             name: "Requisition Created",
//             value: "REQUISITION_CREATED",
//           },
//           {
//             name: "Requisition Deleted",
//             value: "REQUISITION_DELETED",
//           },
//           {
//             name: "Requisition Approval Needed",
//             value: "REQUISITION_APPROVAL_NEEDED",
//           },
//           {
//             name: "Requisition Approved",
//             value: "REQUISITION APPROVED",
//           },
//           {
//             name: "Requisition Rejected",
//             value: "REQUISITION_REJECTED",
//           },
//         ],
//       },
//       {
//         name: "Transfer Management",
//         value: "TRANSFER_MANAGEMENT",
//         children: [
//           {
//             name: "Transfer Created - Full",
//             value: "TRANSFER_CREATED_FULL",
//           },
//           {
//             name: "Transfer Created - Partial",
//             value: "TRANSFER_CREATED_PARTIAL",
//           },
//           {
//             name: "Requisition Approval Needed",
//             value: "REQUISITION_APPROVAL_NEEDED",
//           },
//           {
//             name: "Transfer Edit",
//             value: "TRANSFER_EDIT",
//           },
//           {
//             name: "Transfer Delete",
//             value: "TRANSFER_DELETE",
//           },
//         ],
//       },
//       {
//         name: "Inward",
//         value: "INWARD",
//         children: [
//           {
//             name: "Inward Created - Full",
//             value: "INWARD_CREATED_FULL",
//           },
//           {
//             name: "Inward Created - Partial",
//             value: "INWARD_CREATED_PARTIAL",
//           },
//           {
//             name: "Inward Deleted",
//             value: "INWARD_DELETED",
//           },
//           {
//             name: "Inward - Rate Change",
//             value: "INWARD_RATE_CHANGE",
//           },
//         ],
//       },
//       {
//         name: "Physical Stock Management",
//         value: "PHYSICAL_STOCK_MANAGEMENT",
//         children: [
//           {
//             name: "Physical Stock Count Created",
//             value: "PHYSICAL_STOCK_COUNT_CREATED",
//           },
//           {
//             name: "Physical Stock Count Edited",
//             value: "PHYSICAL_STOCK_COUNT_EDITED",
//           },
//           {
//             name: "Physical Stock Count Deleted",
//             value: "PHYSICAL_STOCK_COUNT_DELETED",
//           },
//           {
//             name: "Stock Count Reminder",
//             value: "STOCK_COUNT_REMINDER",
//           },
//         ],
//       },
//       {
//         name: "Physical Stock Management",
//         value: "PHYSICAL_STOCK_MANAGEMENT",
//         children: [
//           {
//             name: "Physical Stock Count Created",
//             value: "PHYSICAL_STOCK_COUNT_CREATED",
//           },
//           {
//             name: "Physical Stock Count Edited",
//             value: "PHYSICAL_STOCK_COUNT_EDITED",
//           },
//           {
//             name: "Physical Stock Count Deleted",
//             value: "PHYSICAL_STOCK_COUNT_DELETED",
//           },
//           {
//             name: "Stock Count Reminder",
//             value: "STOCK_COUNT_REMINDER",
//           },
//         ],
//       },
//     ],
//   },
// ];

export const notificationDataCategories = [
  {
    name: "Business and Finance",
    value: "BUSINESS_AND_FINANCE",
    children: [
      {
        name: "Daily Business Reports",
        value: "DAILY_BUSINESS_REPORTS",
        children: [
          {
            name: "Day End Business Report",
            value: "DAY_END_BUSINESS_REPORT",
          },
          {
            name: "Counter Closure Report",
            value: "COUNTER_CLOSURE_REPORT",
          },
          {
            name: "Counter Open Report",
            value: "COUNTER_OPEN_REPORT",
          },
        ],
      },
      {
        name: "Accounts",
        value: "ACCOUNTS",
        children: [
          {
            name: "Credit Entry Created",
            value: "CREDIT_ENTRY_CREATED",
          },
          {
            name: "Credit Entry Deleted",
            value: "CREDIT_ENTRY_DELETED",
          },
          {
            name: "Debit Entry Created",
            value: "DEBIT_ENTRY_CREATED",
          },
          {
            name: "Debit Entry Deleted",
            value: "DEBIT_ENTRY_DELETED",
          },
          {
            name: "Internal Transfer Entry Created",
            value: "INTERNAL_TRANSFER_ENTRY_CREATED",
          },
          {
            name: "Internal Transfer Entry Deleted",
            value: "INTERNAL_TRANSFER_ENTRY_DELETED",
          },
        ],
      },
    ],
  },
  {
    name: "Inventory Management",
    value: "INVENTORY_MANAGEMENT",
    children: [
      {
        name: "Stock Alerts",
        value: "STOCK_ALERTS",
        children: [
          {
            name: "Low Stock Alert",
            value: "LOW_STOCK_ALERT",
          },
        ],
      },
      {
        name: "Purchase Orders (PO)",
        value: "PURCHASE_ORDERS_(PO)",
        children: [
          {
            name: "PO Created",
            value: "PO_CREATED",
          },
          {
            name: "PO Edited",
            value: "PO_EDITED",
          },
          {
            name: "PO Deleted",
            value: "PO_DELETED",
          },
          {
            name: "PO Approval Needed",
            value: "PO_APPROVAL_NEEDED",
          },
          {
            name: "PO Approved",
            value: "PO_APPROVED",
          },
          {
            name: "PO Canceled",
            value: "PO_CANCELED",
          },
          {
            name: "PO Rejected",
            value: "PO_REJECTED",
          },
        ],
      },
      {
        name: "Requisitions",
        value: "REQUISITIONS",
        children: [
          {
            name: "Requisition Created",
            value: "REQUISITION_CREATED",
          },
          {
            name: "Requisition Deleted",
            value: "REQUISITION_DELETED",
          },
          {
            name: "Requisition Approval Needed",
            value: "REQUISITION_APPROVAL_NEEDED",
          },
          {
            name: "Requisition Approved",
            value: "REQUISITION_APPROVED",
          },
          {
            name: "Requisition Rejected",
            value: "REQUISITION_REJECTED",
          },
        ],
      },
      {
        name: "Transfer Management",
        value: "TRANSFER_MANAGEMENT",
        children: [
          {
            name: "Transfer Created - Full",
            value: "TRANSFER_CREATED_FULL",
          },
          {
            name: "Transfer Created - Partial",
            value: "TRANSFER_CREATED_PARTIAL",
          },
          {
            name: "Transfer Edit",
            value: "TRANSFER_EDIT",
          },
          {
            name: "Transfer Delete",
            value: "TRANSFER_DELETE",
          },
        ],
      },
      {
        name: "Inward",
        value: "INWARD",
        children: [
          {
            name: "Inward Created - Full",
            value: "INWARD_CREATED_FULL",
          },
          {
            name: "Inward Created - Partial",
            value: "INWARD_CREATED_PARTIAL",
          },
          {
            name: "Inward Deleted",
            value: "INWARD_DELETED",
          },
          {
            name: "Inward - Rate Change",
            value: "INWARD_RATE_CHANGE",
          },
        ],
      },
      {
        name: "Physical Stock Management",
        value: "PHYSICAL_STOCK_MANAGEMENT",
        children: [
          {
            name: "Physical Stock Count Created",
            value: "PHYSICAL_STOCK_COUNT_CREATED",
          },
          {
            name: "Physical Stock Count Edited",
            value: "PHYSICAL_STOCK_COUNT_EDITED",
          },
          {
            name: "Physical Stock Count Deleted",
            value: "PHYSICAL_STOCK_COUNT_DELETED",
          },
          {
            name: "Stock Count Reminder",
            value: "STOCK_COUNT_REMINDER",
          },
        ],
      },
      {
        name: "Production",
        value: "PRODUCTION",
        children: [
          {
            name: "Production Entry Created",
            value: "PRODUCTION_ENTRY_CREATED",
          },
          {
            name: "Production Entry Edited",
            value: "PRODUCTION_ENTRY_EDITED",
          },
          {
            name: "Production Entry Deleted",
            value: "PRODUCTION_ENTRY_DELETED",
          },
        ],
      },
      {
        name: "Wastage & Adjustments",
        value: "WASTAGE_&_ADJUSTMENTS",
        children: [
          {
            name: "Daily Wastage Created",
            value: "DAILY_WASTAGE_CREATED",
          },
          {
            name: "Manual Adjustment - Add Stock",
            value: "MANUAL_ADJUSTMENT_ADD_STOCK",
          },
          {
            name: "Manual Adjustment - Remove Stock",
            value: "MANUAL_ADJUSTMENT_REMOVE_STOCK",
          },
        ],
      },
    ],
  },
  {
    name: "Master Management",
    value: "MASTER_MANAGEMENT",
    children: [
      {
        name: "Product Categories",
        value: "PRODUCT_CATEGORIES",
        children: [
          {
            name: "Product Category Created",
            value: "PRODUCT_CATEGORY_CREATED",
          },
          {
            name: "Product Category Deleted",
            value: "PRODUCT_CATEGORY_DELETED",
          },
          {
            name: "Product Category Edited",
            value: "PRODUCT_CATEGORY_EDITED",
          },
        ],
      },
      {
        name: "Product",
        value: "PRODUCT",
        children: [
          {
            name: "Product Created - Bulk",
            value: "PRODUCT_CREATED_BULK",
          },
          {
            name: "Product Updated - Bulk",
            value: "PRODUCT_UPDATED_BULK",
          },
          {
            name: "Product Created - Manual",
            value: "PRODUCT_CREATED_MANUAL",
          },
          {
            name: "Product Deleted",
            value: "PRODUCT_DELETED",
          },
          {
            name: "Product Edited",
            value: "PRODUCT_EDITED",
          },
        ],
      },
      {
        name: "Add-Ons Category",
        value: "ADD-ONS_CATEGORY",
        children: [
          {
            name: "Add-on Category Created",
            value: "ADD-ON_CATEGORY_CREATED",
          },
          {
            name: "Add-on Category Deleted",
            value: "ADD-ON_CATEGORY_DELETED",
          },
          {
            name: "Add-on Category Edited",
            value: "ADD-ON_CATEGORY_EDITED",
          },
        ],
      },
      {
        name: "Add-Ons",
        value: "ADD-ONS",
        children: [
          {
            name: "Add-Ons Created - Bulk",
            value: "ADD-ONS_CREATED_BULK",
          },
          {
            name: "Add-Ons Created - Manual",
            value: "ADD-ONS_CREATED_MANUAL",
          },
          {
            name: "Add-Ons Deleted",
            value: "ADD-ONS_DELETED",
          },
          {
            name: "Add-Ons Edited",
            value: "ADD-ONS_EDITED",
          },
        ],
      },
      {
        name: "Other Categories",
        value: "OTHER_CATEGORIES",
        children: [
          {
            name: "Display Category Created",
            value: "DISPLAY_CATEGORY_CREATED",
          },
          {
            name: "Display Category Deleted",
            value: "DISPLAY_CATEGORY_DELETED",
          },
          {
            name: "Item Type Category Edited",
            value: "ITEM_TYPE_CATEGORY_EDITED",
          },
          {
            name: "Display Category Edited",
            value: "DISPLAY_CATEGORY_EDITED",
          },
          {
            name: "Item Type Category Created",
            value: "ITEM_TYPE_CATEGORY_CREATED",
          },
          {
            name: "Item Type Category Deleted",
            value: "ITEM_TYPE_CATEGORY_DELETED",
          },
        ],
      },
      {
        name: "Raw Materials",
        value: "RAW_MATERIALS",
        children: [
          {
            name: "Raw Material Deleted",
            value: "RAW_MATERIAL_DELETED",
          },
          {
            name: "Raw Material Edited",
            value: "RAW_MATERIAL_EDITED",
          },
          {
            name: "Raw Materials Created - Bulk",
            value: "RAW_MATERIALS_CREATED_BULK",
          },
          {
            name: "Raw Materials Created - Manual",
            value: "RAW_MATERIALS_CREATED_MANUAL",
          },
        ],
      },
      {
        name: "Vendor Management",
        value: "VENDOR_MANAGEMENT",
        children: [
          {
            name: "Vendor Created",
            value: "VENDOR_CREATED",
          },
          {
            name: "Vendor Deleted",
            value: "VENDOR_DELETED",
          },
        ],
      },
      {
        name: "Recipe Management",
        value: "RECIPE_MANAGEMENT",
        children: [
          {
            name: "Recipe Created - Manual",
            value: "RECIPE_CREATED_MANUAL",
          },
          {
            name: "Recipe Created - Bulk",
            value: "RECIPE_CREATED_BULK",
          },
          {
            name: "Recipe Edited",
            value: "RECIPE_EDITED",
          },
          {
            name: "Recipe Deleted",
            value: "RECIPE_DELETED",
          },
          {
            name: "Recipe Cost Fluctuation Alert",
            value: "RECIPE_COST_FLUCTUATION_ALERT",
          },
        ],
      },
    ],
  },
  {
    name: "Online Ordering",
    value: "ONLINE_ORDERING",
    children: [
      {
        name: "Item and Outlet Management",
        value: "ITEM_AND_OUTLET_MANAGEMENT",
        children: [
          {
            name: "Item Out of Stock",
            value: "ITEM_OUT_OF_STOCK",
          },
          {
            name: "Outlet ON/OFF",
            value: "OUTLET_ON/OFF",
          },
        ],
      },
      {
        name: "Order Management",
        value: "ORDER_MANAGEMENT",
        children: [
          {
            name: "New Online Order - Self, Z, S, ONDC",
            value: "NEW_ONLINE_ORDER_SELF,_Z,_S,_ONDC",
          },
          {
            name: "Order Rejected - Self",
            value: "ORDER_REJECTED_SELF",
          },
          {
            name: "Order Rejected/Cancelled - Customer",
            value: "ORDER_REJECTED/CANCELLED_CUSTOMER",
          },
          {
            name: "Order Preparation Time Exceeded",
            value: "ORDER_PREPARATION_TIME_EXCEEDED",
          },
        ],
      },
    ],
  },
  {
    name: "POS Operations",
    value: "POS_OPERATIONS",
    children: [
      {
        name: "Order Level Exceptions",
        value: "ORDER_LEVEL_EXCEPTIONS",
        children: [
          {
            name: "Discounted Order",
            value: "DISCOUNTED_ORDER",
          },
          {
            name: "Charge Removal",
            value: "CHARGE_REMOVAL",
          },
          {
            name: "Refund Given",
            value: "REFUND_GIVEN",
          },
          {
            name: "Remove Order",
            value: "REMOVE_ORDER",
          },
          {
            name: "Reopen Order",
            value: "REOPEN_ORDER",
          },
          {
            name: "Table Shift After Bill Print",
            value: "TABLE_SHIFT_AFTER_BILL_PRINT",
          },
          {
            name: "Table Merge After Bill Print",
            value: "TABLE_MERGE_AFTER_BILL_PRINT",
          },
          {
            name: "Add Items After Bill Print",
            value: "ADD_ITEMS_AFTER_BILL_PRINT",
          },
        ],
      },
      {
        name: "Discount Operations",
        value: "DISCOUNT_OPERATIONS",
        children: [
          {
            name: "High Discount Alert",
            value: "HIGH_DISCOUNT_ALERT",
          },
          {
            name: "Discount Approval Rejected",
            value: "DISCOUNT_APPROVAL_REJECTED",
          },
        ],
      },
      {
        name: "Item Level Exceptions",
        value: "ITEM_LEVEL_EXCEPTIONS",
        children: [
          {
            name: "Cancel Item",
            value: "CANCEL_ITEM",
          },
          {
            name: "Discount Item",
            value: "DISCOUNT_ITEM",
          },
          {
            name: "Item Returned",
            value: "ITEM_RETURNED",
          },
          {
            name: "Shift Item",
            value: "SHIFT_ITEM",
          },
        ],
      },
      {
        name: "Outstanding Order",
        value: "OUTSTANDING_ORDER",
        children: [
          {
            name: "Pay Later Orders",
            value: "PAY_LATER_ORDERS",
          },
          {
            name: "Payment Received Against Outstanding",
            value: "PAYMENT_RECEIVED_AGAINST_OUTSTANDING",
          },
          {
            name: "Write-Off Outstanding Amount",
            value: "WRITE-OFF_OUTSTANDING_AMOUNT",
          },
        ],
      },
      {
        name: "Reprint",
        value: "REPRINT",
        children: [
          {
            name: "Reprint Bill",
            value: "REPRINT_BILL",
          },
          {
            name: "Reprint KOT",
            value: "REPRINT_KOT",
          },
        ],
      },
      {
        name: "Item Validation",
        value: "ITEM_VALIDATION",
        children: [
          {
            name: "Custom Item Punched",
            value: "CUSTOM_ITEM_PUNCHED",
          },
          {
            name: "Item Rate Change in Order",
            value: "ITEM_RATE_CHANGE_IN_ORDER",
          },
          {
            name: "Tables Not Closed Post Day Close",
            value: "TABLES_NOT_CLOSED_POST_DAY_CLOSE",
          },
        ],
      },
      {
        name: "Kitchen & Operations",
        value: "KITCHEN_&_OPERATIONS",
        children: [
          {
            name: "Kitchen Order Delay Alert",
            value: "KITCHEN_ORDER_DELAY_ALERT",
          },
          {
            name: "Table Turnover Alert",
            value: "TABLE_TURNOVER_ALERT",
          },
        ],
      },
      {
        name: "Tax Validation",
        value: "TAX_VALIDATION",
        children: [
          {
            name: "Incorrect Tax % (GST: 5,12,18,28)",
            value: "INCORRECT_TAX_%_(GST:_5,12,18,28)",
          },
          {
            name: "Tax Missing in Order",
            value: "TAX_MISSING_IN_ORDER",
          },
          {
            name: "VAT Open-Ended",
            value: "VAT_OPEN-ENDED",
          },
        ],
      },
      {
        name: "Future Orders",
        value: "FUTURE_ORDERS",
        children: [
          {
            name: "Future Order Consolidated List",
            value: "FUTURE_ORDER_CONSOLIDATED_LIST",
          },
          {
            name: "Future Order Created",
            value: "FUTURE_ORDER_CREATED",
          },
          {
            name: "Future Order Delivery Date Changed",
            value: "FUTURE_ORDER_DELIVERY_DATE_CHANGED",
          },
        ],
      },
    ],
  },
  {
    name: "User & Compliance",
    value: "USER_&_COMPLIANCE",
    children: [
      {
        name: "User Management",
        value: "USER_MANAGEMENT",
        children: [
          {
            name: "User Created",
            value: "USER_CREATED",
          },
          {
            name: "User Deleted",
            value: "USER_DELETED",
          },
          {
            name: "User Edited",
            value: "USER_EDITED",
          },
        ],
      },
      {
        name: "User Permission",
        value: "USER_PERMISSION",
        children: [
          {
            name: "User Permission Edited",
            value: "USER_PERMISSION_EDITED",
          },
        ],
      },
    ],
  },
];

export function fuzzyFilterNestedArray(data, searchTerm) {
  const lowerSearch = searchTerm.toLowerCase();

  return data
    .map((section) => {
      const matchedChildren = section.children && section.children.filter((child) => child.name.toLowerCase().includes(lowerSearch));

      if (matchedChildren && matchedChildren.length > 0) {
        return { ...section, children: matchedChildren };
      }

      return null;
    })
    .filter(Boolean);
}
